import { Button, Col, Row } from "antd";

import { PlusOutlined } from "@ant-design/icons";

import { AdminMenuLayout } from "../../../shared/components";
import { useWorkOffers } from "../hook";
import { WrapperCardWorkOffers } from "./styled";
import { TableWorkOffers } from "./TableWorkOffers";

export const WorkOffers = () => {
  const { changeModalWorkOffersState } = useWorkOffers();

  return (
    <AdminMenuLayout pageDescription="WorkOffers" title="WorkOffers">
      <WrapperCardWorkOffers>
        <Row
          gutter={[8, 8]}
          style={{
            padding: "10px",
            width: "100%",
          }}
        >
          <Col
            span={24}
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <Button
              type="primary"
              shape="round"
              icon={<PlusOutlined />}
              size="large"
              onClick={changeModalWorkOffersState}
            >
              Agregar nueva oferta de trabajo
            </Button>
          </Col>
        </Row>
        <TableWorkOffers />
      </WrapperCardWorkOffers>
    </AdminMenuLayout>
  );
};
